<template lang="">
    <div class="modal fade" :id="modalId" tabindex="-1" :aria-labelledby="`${modalId}-label`" ref="modalEl" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title-danger" :id="`${modalId}-label`">{{ title }}</div>
        <button class="btn btn-default btn-sm close-btn-danger" @click="handleClose">
            <CloseIcon/>
          </button>
      </div>
      <div class="modal-body" v-html="body">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="handleClose" style="border:1px solid red;background:transparent;color:var(--red);">{{noButtonLabel}}</button>
        <button type="button" class="btn btn-secondary" @click="yesSelected" style="background:var(--red);color:white;border:0px;" :disabled="loading">{{ loading == true? loadingButtonLabel : yesButtonLabel}}</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import { Modal } from 'bootstrap';
  import CloseIcon from '../IconComponents/CloseIcon.vue';
export default {
    components:{
      CloseIcon
    },
    data(){
      return{
        loading:false
      }
    },
    props:{
        closeModal:{
            type: Function
                    
        },
        title:{
            type: String
        },
        body:{
            type: String
        },
        yesSelected:{
            type: Function
        },
         modalId:{
            type: String
        },
        yesButtonLabel:{
          type:String
        },
        loadingButtonLabel:{
          type:String
        },
        noButtonLabel:{
          type:String
        },
    },
     mounted() {
    this.modalInstance = new Modal(this.$refs.modalEl);
  },
    methods: {
      show() {
        this.modalInstance?.show();
      },
      hide() {
        this.modalInstance?.hide();
      },
      startLoading(){
        this.loading = true;
      },
      stopLoading(){
        this.loading = false;
      },
      handleClose() {
        this.hide();
        if (typeof this.closeModal === 'function') {
          this.closeModal();
        }
      }
    }
}
</script>
<style scoped>
    .modal-title{
        color:red;
    }

    
</style>